import predictor from '@/lib/content/predictor.json';
import { DEFAULT_LOCALE } from '@/lib/config';

export type Venue = { name: string; city: string };

export type LocaleContent = {
  teams: Record<string, string>;
  venues: Record<string, Venue>;
  dates: Record<string, string>;
  unionOptins: Record<string, string>;
};

const RAW = predictor as unknown as Record<string, Partial<LocaleContent>>;
const FALLBACK = RAW[DEFAULT_LOCALE] as LocaleContent;

function pick<K extends keyof LocaleContent>(
  source: Partial<LocaleContent> | undefined,
  key: K,
): LocaleContent[K] {
  const value = source?.[key];
  if (value && Object.keys(value as object).length > 0) return value as LocaleContent[K];
  return FALLBACK[key];
}

export function resolveContent(locale: Locale): LocaleContent {
  const source = RAW[locale];
  return {
    teams: pick(source, 'teams'),
    venues: pick(source, 'venues'),
    dates: pick(source, 'dates'),
    unionOptins: pick(source, 'unionOptins'),
  };
}
